module.exports = __webpack_public_path__ + "img/1791991495614.b53e1009.png";